import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, reactive, getCurrentInstance } from 'vue';
import colors from '@/styles/color.scss';
import moment from 'moment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'specialDate',
    props: {
        mustDate: {
            type: Array,
            default: () => [],
        },
        noCheckDate: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['change'],
    setup(__props, { emit }) {
        const props = __props;
        const vm = getCurrentInstance()?.proxy;
        const dateFormat = ref('yyyy-MM-dd');
        const dialogInfo = reactive({
            title: '',
            key: 'mustDate',
            visible: false,
            addType: 'singleDate',
            selectDates: [],
            singleDate: '',
        });
        const tablesData = reactive({
            mustDate: [],
            noCheckDate: [],
        });
        const disabledSave = ref(false);
        const tips = ref('');
        const tables = ref([
            {
                key: 'mustDate',
                height: 250,
                btn: {
                    key: 'mustDate',
                    label: vm?.$t('addMustDate'),
                    icon: 'add-icon',
                    color: colors.release,
                    dialogTitle: vm?.$t('addMustDateTitle'),
                },
                columns: [
                    {
                        type: '',
                        key: 'date',
                        label: vm?.$t('date'),
                    },
                    {
                        type: 'btns',
                        key: 'operation',
                        label: vm?.$t('operation'),
                        btns: {
                            key: 'delete',
                            label: vm?.$t('delete'),
                            color: colors.release,
                        },
                    },
                ],
            },
            {
                key: 'noCheckDate',
                height: 250,
                btn: {
                    key: 'noCheckDate',
                    label: vm?.$t('addNoCheckDate'),
                    icon: 'add-icon',
                    color: colors.release,
                    dialogTitle: vm?.$t('addNoCheckDateTitle'),
                },
                columns: [
                    {
                        key: 'date',
                        label: vm?.$t('date'),
                    },
                    {
                        type: 'btns',
                        key: 'operation',
                        label: vm?.$t('operation'),
                        btns: {
                            key: 'delete',
                            label: vm?.$t('delete'),
                            color: colors.release,
                        },
                    },
                ],
            },
        ]);
        watch(() => props.mustDate, (nv) => {
            tablesData.mustDate = nv;
        }, { deep: true, immediate: true });
        watch(() => props.noCheckDate, (nv) => {
            tablesData.noCheckDate = nv;
        }, { deep: true, immediate: true });
        function handleAdd(type, title) {
            dialogInfo.key = type;
            dialogInfo.title = title;
            dialogInfo.visible = true;
        }
        function handleChangeDate(type) {
            const dialogKey = dialogInfo.key;
            const compareDates = tablesData[dialogKey === 'mustDate' ? 'noCheckDate' : 'mustDate'];
            const curDate = dialogInfo[type];
            const targetDaes = curDate instanceof Array ? curDate : (curDate && [curDate]) || [];
            const selectDates = creatDatesByScope(targetDaes);
            const errorDate = [];
            selectDates?.forEach((i) => {
                const repeatDate = compareDates?.find((c) => c === i);
                repeatDate && errorDate.push(repeatDate);
            });
            const errorKey = dialogKey === 'mustDate' ? 'dateMustErrorTips' : 'dateNoCheckErrorTips';
            tips.value = errorDate?.length > 0 ? `${vm?.$t(errorKey, { dates: errorDate.join('、') })}` : '';
            disabledSave.value = errorDate?.length > 0;
        }
        function changeSelectDateType() {
            dialogInfo.selectDates = [];
            dialogInfo.singleDate = '';
            disabledSave.value = false;
            tips.value = '';
        }
        function handleClose() {
            dialogInfo.visible = false;
            dialogInfo.addType = 'singleDate';
            dialogInfo.selectDates = [];
            dialogInfo.singleDate = '';
            tips.value = '';
            disabledSave.value = false;
        }
        function creatDatesByScope(dates) {
            if (dates?.length !== 2)
                return dates;
            const format = 'yyyy-MM-DD';
            const startDate = moment(dates[0]);
            const endDate = moment(dates[1]);
            const totalDays = Math.abs(startDate.diff(endDate, 'days'));
            const targetDays = [startDate.format(format)];
            for (let i = 0; i < totalDays; i++) {
                startDate.add(1, 'day');
                targetDays.push(startDate.format(format));
            }
            return targetDays;
        }
        function saveDate() {
            // todo 添加日期
            const dialogKey = dialogInfo.key;
            const addType = dialogInfo.addType;
            const selectDates = dialogInfo?.[addType];
            const scopeDates = selectDates instanceof Array ? selectDates : selectDates ? [selectDates] : [];
            const addDates = creatDatesByScope(scopeDates);
            const originDates = tablesData?.[dialogKey] ?? [];
            const targetDates = [...new Set([...originDates, ...addDates])].sort((a, b) => {
                return a > b ? 1 : -1;
            });
            tablesData[dialogKey] = targetDates;
            emit('change', { ...tablesData });
            handleClose();
        }
        function deleteDate(type, date) {
            tablesData[type] = tablesData[type].filter((d) => d !== date);
            emit('change', { ...tablesData });
        }
        return { __sfc: true, vm, props, dateFormat, dialogInfo, tablesData, emit, disabledSave, tips, tables, handleAdd, handleChangeDate, changeSelectDateType, handleClose, creatDatesByScope, saveDate, deleteDate };
    }
});
